'use strict';exports.__esModule = true;var validateManual = function validateManual(values) {
  var errors = {};

  if (
  !values.primary ||
  !values.primary.name ||
  !values.primary.name.length)
  {
    errors.primary = Object.assign({}, errors.primary || {}, { name: 'required' });
  }

  if (
  !values.primary ||
  !values.primary.value ||
  !values.primary.value.length)
  {
    errors.primary = Object.assign({}, errors.primary || {}, { value: 'required' });
  }
  return errors;
};exports.default =

validateManual;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UpdatePropertyActivityModal/ManualForm/validate.js
// module id = 2926
// module chunks = 0